import type { FC } from 'react';
import { memo, useCallback } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { GraphModal } from '../../../components/GraphModal/GraphModal';
import { Tooltip } from '../../../components/GraphModal/Tooltip';
import { IconWarning } from '../../../components/icons/Icons';
import { ThreadOptionsStructure } from '../ThreadOptionStructure';
import type { ReportCommentProps } from './Report';
import { ReportComment } from './Report';

const messages = defineMessages({
  label: { defaultMessage: 'Report message', id: 'qOg/pE' },
  report: { defaultMessage: 'Report an offense', id: 'D48+K2' },
});

interface ReportMenuItemProps extends ReportCommentProps {}

export const ReportMenuItem: FC<ReportMenuItemProps> = memo(function ReportMenuItem(props) {
  const { id, object, className } = props;

  const lazyRender = useCallback(
    tip => <ReportComment controller={tip} id={id} object={object} />,
    [id, object],
  );

  return (
    <GraphModal maxWidth={400} lazyContent={lazyRender} showPageOverlay forceModal>
      <div className={className}>
        <Tooltip content={<FormattedMessage {...messages.report} />}>
          <ThreadOptionsStructure
            title={<FormattedMessage {...messages.label} />}
            subtitle={null}
            icon={<IconWarning className="w-4 h-4 text-current" />}
          />
        </Tooltip>
      </div>
    </GraphModal>
  );
});
